export type Locale = 'de' | 'en';
export const defaultLocale: Locale = 'de';
export const locales: Locale[] = ['de', 'en'];

export function isValidLocale(locale: string): locale is Locale {
    return locales.includes(locale as Locale);
}
